import { Flex, Form, Radio, Select, Text } from '@approvalmax/ui/src/components';
import { TypeOfBusiness } from 'modules/data/domain';
import { memo } from 'react';

import { fields, numberOfClientsItems, numberOfEntitiesItems, partnerStatusItems, useCaseItems } from '../../constants';
import { useProfileSetupFormContext } from '../ProfileSetupForm/ProfileSetupForm.hooks';
import { useProductInterestItems } from './FormSectionQualificationQuestions.hooks';
import { messages } from './FormSectionQualificationQuestions.messages';

export const FormSectionQualificationQuestions = memo(() => {
    const { watch } = useProfileSetupFormContext();
    const productInterestItems = useProductInterestItems();

    const [typeOfBusiness, partnerStatus, productInterest, numberOfEntities, numberOfClients] = watch([
        fields.fieldNameTypeOfBusiness,
        fields.fieldNamePartnerStatus,
        fields.fieldNameProductInterest,
        fields.fieldNameNumberOfEntities,
        fields.fieldNameNumberOfClients,
        fields.fieldNameUseCase,
    ]);

    return (
        <Form.Part>
            <Flex direction='column' spacing='8' container>
                <Text font='label' fontSize='medium' fontWeight='medium'>
                    {messages.title}
                </Text>

                <Radio.Group name={fields.fieldNameTypeOfBusiness} direction='column' spacing='8'>
                    <Radio value={TypeOfBusiness.Partner}>{messages.companyPartner}</Radio>

                    <Radio value={TypeOfBusiness.Business}>{messages.companyBusiness}</Radio>
                </Radio.Group>
            </Flex>

            {typeOfBusiness && (
                <Flex direction='column' spacing='8' container>
                    {typeOfBusiness === TypeOfBusiness.Partner && (
                        <Select
                            name={fields.fieldNamePartnerStatus}
                            items={partnerStatusItems}
                            placeholder={messages.partnerStatusPlaceholder}
                            itemIdKey='id'
                            itemNameKey='text'
                        />
                    )}

                    {typeOfBusiness === TypeOfBusiness.Partner && !!partnerStatus && (
                        <Select
                            name={fields.fieldNameNumberOfClients}
                            items={numberOfClientsItems}
                            placeholder={messages.numberOfClientsPlaceholder}
                            itemIdKey='id'
                            itemNameKey='text'
                        />
                    )}

                    {typeOfBusiness === TypeOfBusiness.Business && (
                        <Select
                            name={fields.fieldNameProductInterest}
                            items={productInterestItems}
                            placeholder={messages.productInterestPlaceholder}
                            itemIdKey='id'
                            itemNameKey='text'
                        />
                    )}

                    {typeOfBusiness === TypeOfBusiness.Business && !!productInterest && (
                        <Select
                            name={fields.fieldNameNumberOfEntities}
                            items={numberOfEntitiesItems}
                            placeholder={messages.numberOfEntitiesPlaceholder}
                            itemIdKey='id'
                            itemNameKey='text'
                        />
                    )}

                    {((typeOfBusiness === TypeOfBusiness.Partner && !!partnerStatus && !!numberOfClients) ||
                        (typeOfBusiness === TypeOfBusiness.Business && !!productInterest && !!numberOfEntities)) && (
                        <>
                            <Select
                                multiple
                                name={fields.fieldNameUseCase}
                                items={useCaseItems}
                                placeholder={messages.useCasePlaceholder}
                                itemIdKey='id'
                                itemNameKey='text'
                            />
                        </>
                    )}
                </Flex>
            )}
        </Form.Part>
    );
});

FormSectionQualificationQuestions.displayName = 'QualificationQuestions';
